import React from 'react';

import type { LocalNotificationProps } from '@core/notifications/LocalNotification';
import { LocalNotification } from '@core/notifications/LocalNotification';
import type { NotificationSeverity } from '@core/notifications/types';

import { inlineNotificationCss, classes } from './inlineNotificationCss';
import InlineSeverityIcon from './InlineSeverityIcon';

export type InlineNotificationProps = {
  /**
   * Notification title.
   */
  title?: string;
  /**
   * Severity type of Notification
   * @default information
   */
  severity?: NotificationSeverity;
} & Omit<LocalNotificationProps, 'titleProps' | 'severity' | 'severityIcon'>;

/**
 * Inline notifications are system notifications that appear at the component level to
 * communicate task related feedback or action.
 *
 * See [Props](__storybookUrl__/components-feedback-notifications--default#props)
 */
const InlineNotification = React.forwardRef(function InlineNotification(
  props: InlineNotificationProps,
  ref: React.Ref<HTMLDivElement>
) {
  const { title, severity, ...rest } = props;

  return (
    <LocalNotification
      {...rest}
      ref={ref}
      css={inlineNotificationCss}
      severity={severity || 'information'}
      severityIcon={<InlineSeverityIcon severity={severity || 'information'} />}
      titleProps={{
        component: 'p',
        severity: severity,
        children: title,
        className: classes.inlineNotificationTitle,
      }}
    />
  );
});

export default InlineNotification;
